import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BanknotesIcon, QueueListIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface NavigationItemsProps {
  className?: string;
  showLabels?: boolean;
}

export const NavigationItems: React.FC<NavigationItemsProps> = ({
  className = '',
  showLabels = false,
}) => {
  const location = useLocation();
  const { t } = useTranslation();

  const navigationItems = [
    {
      to: '/budgets/current',
      icon: BanknotesIcon,
      label: t('navigation.dashboard'),
    },
    {
      to: '/budgets',
      icon: QueueListIcon,
      label: t('navigation.history'),
    },
  ];

  return (
    <div className={`flex items-center ${className}`}>
      {navigationItems.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className={`flex items-center rounded-md px-2 py-2 text-sm font-medium transition-colors lg:px-3 ${
            location.pathname === item.to
              ? 'text-indigo-600 dark:text-indigo-400'
              : 'text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-white'
          }`}
          title={item.label}
        >
          <item.icon className="h-5 w-5" />
          {showLabels && <span className="ml-1">{item.label}</span>}
        </Link>
      ))}
    </div>
  );
};
